import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, bool_type, class_type, list_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Dashboard_Lists_AnstehendeZahlungDetailsBlock_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["List"];
    }
}

export function Page_$reflection() {
    return union_type("Zahlungen.Types.Page", [], Page, () => [[]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "DataLoaded", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Zahlungen.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Dashboard_Lists_AnstehendeZahlungDetailsBlock_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(Dashboard_Lists_AnstehendeZahlungDetailsBlock_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Record {
    constructor(Loading, Data) {
        super();
        this.Loading = Loading;
        this.Data = Data;
    }
}

export function Model_$reflection() {
    return record_type("Zahlungen.Types.Model", [], Model, () => [["Loading", bool_type], ["Data", list_type(Dashboard_Lists_AnstehendeZahlungDetailsBlock_$reflection())]]);
}

//# sourceMappingURL=Types.fs.js.map
